// ----------------------------------------------------------------------------
// Template: Article
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/social-sharing/social-sharing';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/pagination/pagination';
import 'sections/header/header';
import 'sections/main-article/main-article';
import 'sections/footer/footer';